<div class="listingPage__Head">
  <div class="listPage__Title">
    @if (orgName) {
      <div>
        You are viewing <span [innerHTML]="headerTitle"></span> of {{orgName+' '}}
        @if (orgName) {
          <img class="close-icon" (click)="clearSearch()" src="../../../../assets/Images/user-management/Cross.svg" alt="">
        }
      </div>
    }
    @if (!orgName) {
      <div>
       <span [innerHTML]="headerTitle"></span>
        @if (dashBoard) {
          <img class="close-icon" (click)="clearSearch()"  src="../../../../assets/Images/user-management/Cross.svg" alt="">
        }
      </div>
    }
  </div>
  @if (headerDescription) {
    <div class="listPage__Description"  [innerHTML]="headerDescription">
    </div>
  }
</div>
